<template>
    <nav class="breadcrumb is-small" aria-label="breadcrumbs">
         <ul>
             <li
             v-for="(crumb, index) in breadcrumbItems"
             :key="index"
             v-bind:class="{ 'is-active': crumb.isActive }">
              <a href="#" aria-current="page"> {{crumb.name}} </a>
            </li>
         </ul>
    </nav>
</template>

<script>
export default {
  name: "app-breadcrumd",
  props: {
      breadcrumbItems: Array
  }
};
</script>




// WEBPACK FOOTER //
// src/components/AppBreadcrumb.Vue